import React from "react";
import Carousel from 'react-bootstrap/Carousel'
import './Banner.scss'
import appImg1 from 'assets/img/screenshot/ic-screenshot-1.png'
import appImg2 from 'assets/img/screenshot/ic-screenshot-2.png'
import appImg3 from 'assets/img/screenshot/ic-screenshot-3.png'
import appImg4 from 'assets/img/screenshot/ic-screenshot-4.png'
import appImg5 from 'assets/img/screenshot/ic-screenshot-5.png'

export const Banner: React.FC = () => {
  return (
    <div className="banner">
      <div className="banner-bg-img"></div>
      <div className="banner-content container">
      <div className="banner-left-container">
          <h1 className="slogn">
            <strong>
            Secure & Free VPN for iPhone and Android</strong>
          </h1>
        <div className="banner-download-wrap">
          <div className="link">
            <a href="https://apps.apple.com/app/vpn-super-vpn-security-proxy/id1507763697">
              <img src={require("assets/img/app-store.png")} alt="" />
            </a>
          </div>
          {/* <div className="link">
            <a href="https://play.google.com/store/apps/details?id=com.super.english.translate">
              <img src={require("assets/img/google-btn.png")} alt="" />
            </a>
          </div> */}
        </div>
      </div>
        <div className="img-placeholder-frame">
          <div className="carousel-frame">
          <Carousel indicators={false} controls={false}>
            <Carousel.Item>
              <img src={appImg1} alt="launch" />
            </Carousel.Item>
            <Carousel.Item>
              <img src={appImg2} alt="home" />
            </Carousel.Item>
            <Carousel.Item>
              <img src={appImg3} alt="home" />
            </Carousel.Item>
            <Carousel.Item>
              <img src={appImg4} alt="home" />
            </Carousel.Item>
            <Carousel.Item>
              <img src={appImg5} alt="home" />
            </Carousel.Item>
          </Carousel>
          </div>
          <img className="placeholder-img" src={require('assets/img/ic-iphone-border.png')} alt="" />
        </div>
        </div>
      </div>
  );
};
